import { render, staticRenderFns } from "./applySales.vue?vue&type=template&id=62fab0db&scoped=true"
import script from "./applySales.vue?vue&type=script&lang=js"
export * from "./applySales.vue?vue&type=script&lang=js"
import style0 from "./applySales.vue?vue&type=style&index=0&id=62fab0db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fab0db",
  null
  
)

export default component.exports